import { action, makeObservable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import type { RepositoryVehicleDevices } from "../../domain/repositories/repository-vehicle-devices";
import { type UUID } from "../../utils/uuid";
import { ListCommandButtons, type ListCommandButtonsProps } from "./list-command-buttons";
import { FormUpdateVehicleDevice } from "../molecules/form-update-vehicle-device";

export type ListCommandButtonsVehicleDevicesProps = Omit<
    ListCommandButtonsProps<RepositoryVehicleDevices>,
    "list" | "createForm" | "listState"
>;

import { store } from "../../store";

@observer
export class ListCommandButtonsVehicleDevices extends React.Component<ListCommandButtonsVehicleDevicesProps> {
    constructor(props: ListCommandButtonsVehicleDevicesProps) {
        super(props);
        makeObservable(this);
    }

    @action.bound private async deleteVehicleDevices(ids: UUID[]): Promise<void> {
        await store.repositoryVehicleDevices.delete(...ids);
        if (this.props.onDelete) {
            this.props.onDelete(ids);
        }
    }
    public render(): JSX.Element {
        return (
            <ListCommandButtons
                updateForm={FormUpdateVehicleDevice}
                listState={store.serviceListStates.vehicleDevices}
                {...this.props}
                onDelete={this.deleteVehicleDevices}
            />
        );
    }
}
